import React, {useEffect, useState} from "react";
import './AreaInfo.scss';

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import {useNavigate, useParams} from "react-router-dom";
import TicketComponent from "../../components/Card/Ticket/TicketComponent";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";
import Alert from "react-bootstrap/Alert";
import society from "../Info/Society";
import {getDay, parse} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faClock, faClockFour} from "@fortawesome/free-solid-svg-icons";
import {ProgressBar} from "react-bootstrap";

let img_top = require("../../assets/Blog.jpg");

function AreaInfo() {
    const navigate = useNavigate();

    const {area_id} = useParams();
    const [area, setArea] = useState(null);
    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        fetch(global.route.areaInfo, {
            method: "post",
            credentials: 'include',
            body: global.getFormData({id: area_id}),
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        document.title = "Geoticket - Area " + response.area.name;
                        setArea(response.area);
                        fetch(global.route.areaTickets, {
                            method: "post",
                            credentials: 'include',
                            body: global.getFormData({id: area_id}),
                        })
                            .then(response => {
                                if (response.status === 200) {
                                    response.json().then(response => {
                                        setTickets(response.list);
                                    });
                                }
                            });
                    });
                }
            });
    }, []);

    let senEmailShowcase = () => {
        const email = area.email_showcase;
        let cc = area.email_cc_showcase;
        const subject = "Richiesta attivazione GEOTICKET";
        const body = "Buongiorno,\n" +
            "\n" +
            "nel tentativo di fare il permesso online per il vostro territorio, non ho purtroppo trovato la possibilità di farlo con Geoticket.\n" +
            "\n" +
            "Vi scrivo pertanto per richiedere l’attivazione di questo utile servizio tramite la piattaforma Geoticket, che potete contattare all'indirizzo info@geoticket.it\n" +
            "\n" +
            "Rimango in attesa di un vostro riscontro.";

        let link = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

        if (cc) {
            cc = cc.replace(",", ";");
            link += `&cc=${encodeURIComponent(cc)}`;
        }

        try {
            window.location.href = link;
        } catch (error) {
            toast.error("Non è possibile inviare l'email");
        }
    }

    let getTickets = () => {
        if (area.is_showcase) {
            return (<div className={"container"}>
                <div className={"card"}>
                    <div className={"card-body"}>
                        <b className={"orange"}>Questa zona non ha ancora aderito a Geoticket</b>
                        <p>Ecco come richiedere il permesso e l'attivazione</p>
                        <p>1) Clicca su "richiedi attivazione"<br/>
                            2) Clicca su "invia email"</p>
                        <Button className={"btn-orange"} onClick={() => senEmailShowcase()}>Richiedi
                            attivazione</Button>
                    </div>
                </div>
            </div>);
        }
        if (Object.keys(tickets).length === 0)
            return (<div className={"container"}><Alert variant={"warning"}>Non ci sono ticket disponibili in questa
                area</Alert></div>)
        let result = [];
        for (let ticket of tickets) {
            result.push(<div className={"col-lg-4 col-md-6 pt-2 pb-2"}>
                <TicketComponent ticket={ticket}
                                 onClick={(withAdvantges) => navigate("/event/" + ticket.id + (withAdvantges ? "?advantages=true" : ""))}/>
            </div>)
        }
        return result;
    }

    let getProgress = (lv) => {
        switch (lv) {
            case 0:
                return <ProgressBar variant="progress-16" now={16} label={"Assente"}/>
            case 1:
                return <ProgressBar variant="progress-32" now={32} label={"Insufficiente"}/>
            case 2:
                return <ProgressBar variant="progress-48" now={48} label={"Scarsa"}/>
            case 3:
                return <ProgressBar variant="progress-64" now={64} label={"Buona"}/>
            case 4:
                return <ProgressBar variant="progress-80" now={80} label={"Abbondante"}/>
            case 5:
                return <ProgressBar variant="progress-100" now={100} label={"Miracolosa"}/>
        }
    }

    function getInfo() {
        // if (area.is_showcase)
        //     return;
        console.log("area")
        console.log(area)
        let working_day = null;
        if (typeof area.operating_dates !== "undefined" && area.operating_dates !== null && area.operating_dates.dates_week !== null) {
            const datesWeek = area.operating_dates.dates_week;
            const dayNames = [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
            ];
            const today = new Date();
            const todayName = dayNames[getDay(today)];

            const todaySchedule = datesWeek[todayName];
            let matchedHours = "";
            if (todaySchedule) {
                const now = new Date();

                for (const period of todaySchedule) {
                    const open = parse(period.open, "HH:mm", today);
                    const close = parse(period.close, "HH:mm", today);

                    if (now >= open && now <= close) {
                        matchedHours = `${period.open} - ${period.close}`;
                        break;
                    }
                }
            }

            if (matchedHours !== "") {
                working_day =
                    <div style={{display: "flex", alignItems: "center", gap: 6}}><FontAwesomeIcon icon={faClockFour}/>
                        <span style={{color: "#51b270"}}>Aperto</span>{matchedHours}
                        {/*<FontAwesomeIcon icon={faCaretDown} size="sm"/>*/}
                    </div>;
            } else {
                working_day =
                    <div style={{display: "flex", alignItems: "center", gap: 6}}><FontAwesomeIcon icon={faClockFour}/>
                        <span style={{color: "#FF5722"}}>Chiuso</span>
                        {/*<FontAwesomeIcon icon={faCaretDown} size="sm"/>*/}
                    </div>;
            }
        }
        let mushroom_growth = null;
        if (area.area_level !== null)
            mushroom_growth =
                <div className={"d-flex flex-column"}>Livello crescita funghi {getProgress(area.area_level)}</div>
        let name = area.name;
        if(area.society !== null)
            name = area.society.name;
        return <div style={{backgroundColor: "#fafafa", color: "#212121"}}>
            <div className={"container pt-2 pb-2"}>
                <div className={"col-md-6"}>
                    <b>{name}</b><br/>
                    <small>{area.fullAddress}</small>
                    {working_day}
                    {mushroom_growth}
                </div>
                <div className={"col-md-6"}>
                </div>
            </div>
        </div>;

    }

    let img_bg = img_top;
    let logo = null;
    if (area !== null) {
        if (area.image !== null) {
            img_bg = global.getImage(area.image);
        } else {
            img_bg = global.getImage(area.category.image);
        }
        if (area.logo !== null)
            logo = <div className={"logo"}><img src={global.getImage(area.logo)}/></div>
    }
    if (area === null) {
        return (
            <div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
                <Header/>
                <div className="video-section">
                    <img className="background-video" src={img_bg}/>
                    <div className="overlay-content background">
                        <div>
                            <div className={"container"}>
                                <div style={{flex: 1}}>
                                    <h1 className="title">Area</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>);
    } else {
        return (<div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_bg}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                {logo}
                                <h1 className="title">{area.name}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: "#EEEEEE"}}>
                {getInfo()}
                <div className="container pt-4 pb-4">
                    <div className="row">
                        {getTickets()}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>);
    }
}

export default AreaInfo;